import { InfiniteTable } from '@infinite-table/infinite-react';
export * from '@infinite-table/infinite-react';
import { INFINITE_TABLE_LICENSE_KEY } from '../../EnvVars';
const defaultProps = InfiniteTable.defaultProps;
defaultProps.licenseKey = INFINITE_TABLE_LICENSE_KEY;
defaultProps.sortable = false;
defaultProps.rowHeight = '--ab-grid-row-height';
defaultProps.draggableColumns = false;
defaultProps.keyboardNavigation = false;
export { InfiniteTable };
